<template>
  <div class="main-content-container container">
    <div class="page-header row no-gutters py-4">
      <div class="col-6 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Financeiro</span>
        <h3 class="page-title">Conciliação de Contas a Receber</h3>
      </div>
      <div class="col-6 d-flex">
        <div class="input-group d-flex justify-content-end my-auto">
          <button type="button" class="btn btn-primary btn-sm mt-3" @click="$bvModal.show('mFilter')">
            <i class="fas fa-filter"></i>
            {{ countFilter > 0 ? "Filtros aplicados" : "" }}
            <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
          </button>
          <button
            v-if="countFilter > 0"
            type="button"
            class="input-group-text btn-sm ml-1 mt-3"
            v-b-tooltip.hover.bottom
            title="Limpar filtros"
            @click="ResetFilter()"
          >
            <i class="fas fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>

    <TableListARConciliation
      :lines="items"
      :pagination.sync="pagination"
      :loadingList="loadingList"
      @List="List"
      @Open="OpenItem"
      @ConfirmDelete="ConfirmDelete"
      @ConfirmDeactivate="ConfirmDeactivate"
      @ConfirmActivate="ConfirmActivate"
    />

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mFormItem"
      size="md"
    >
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="FormValidation">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Categoria de Contas a Receber <span class="text-danger">*</span></label>
              <div class="typeahead-wrapper">
                <VueTypeaheadBootstrap
                  v-model="formCategorySearch"
                  :data="categoryOptions"
                  :serializer="item => item.Name"
                  :minMatchingChars="0"
                  :showOnFocus="true"
                  :maxMatches="999"
                  placeholder="Pesquisar categoria..."
                  :disabled="isSeeing"
                  @hit="infoItem.IdAccountsReceivableCategory = $event.Id"
                  @input="onCategoryInput"
                />
                <button v-if="formCategorySearch && !isSeeing" class="typeahead-clear-btn" type="button"
                  @click="formCategorySearch = ''; infoItem.IdAccountsReceivableCategory = null">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <div class="invalid-feedback d-block" v-if="validatedForm && !infoItem.IdAccountsReceivableCategory">
                Campo obrigatório
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Conta Bancária</label>
              <div class="typeahead-wrapper">
                <VueTypeaheadBootstrap
                  v-model="formBankAccountSearch"
                  :data="bankAccountOptions"
                  :serializer="item => item.Bank.Code + ' - ' + item.Bank.Name.trim() + ' Ag: ' + item.BankAgency + '-' + item.BankAgencyDigit + ' CC: ' + item.BankAccount + '-' + item.BankAccountDigit"
                  :minMatchingChars="0"
                  :showOnFocus="true"
                  :maxMatches="999"
                  placeholder="Pesquisar conta bancária..."
                  :disabled="isSeeing"
                  @hit="infoItem.IdBankAccount = $event.Id"
                  @input="onBankAccountInput"
                />
                <button v-if="formBankAccountSearch && !isSeeing" class="typeahead-clear-btn" type="button"
                  @click="formBankAccountSearch = ''; infoItem.IdBankAccount = null">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="8" class="form-group">
              <label>Categoria de Lançamento</label>
              <div class="typeahead-wrapper">
                <VueTypeaheadBootstrap
                  v-model="formEntryCategorySearch"
                  :data="entryCategoryOptions"
                  :serializer="item => item.Code + ' - ' + item.Name"
                  :minMatchingChars="0"
                  :showOnFocus="true"
                  :maxMatches="999"
                  placeholder="Pesquisar categoria..."
                  :disabled="isSeeing"
                  @hit="infoItem.IdEntryCategory = $event.Id"
                  @input="onEntryCategoryInput"
                />
                <button v-if="formEntryCategorySearch && !isSeeing" class="typeahead-clear-btn" type="button"
                  @click="formEntryCategorySearch = ''; infoItem.IdEntryCategory = null">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </d-col>
            <d-col md="4" class="form-group">
              <label>Cód. Histórico</label>
              <d-form-input
                :disabled="isSeeing"
                type="text"
                maxlength="10"
                v-model="infoItem.CodeHistory"
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="Save()"
          v-if="!isSeeing"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ editingId ? "Salvar" : "Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <!-- Modal de filtros -->
    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Categoria de Contas a Receber</label>
          <div class="typeahead-wrapper">
            <VueTypeaheadBootstrap
              v-model="filterCategorySearch"
              :data="categoryOptions"
              :serializer="item => item.Name"
              :minMatchingChars="0"
              :showOnFocus="true"
              :maxMatches="999"
              placeholder="Todos"
              @hit="filter.IdAccountsReceivableCategory = $event.Id"
              @input="filterCategorySearch || (filter.IdAccountsReceivableCategory = null)"
            />
            <button v-if="filterCategorySearch" class="typeahead-clear-btn" type="button"
              @click="filterCategorySearch = ''; filter.IdAccountsReceivableCategory = null">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="form-group">
          <label>Conta Bancária</label>
          <div class="typeahead-wrapper">
            <VueTypeaheadBootstrap
              v-model="filterBankAccountSearch"
              :data="bankAccountOptions"
              :serializer="item => item.Bank.Code + ' - ' + item.Bank.Name.trim() + ' Ag: ' + item.BankAgency + '-' + item.BankAgencyDigit + ' CC: ' + item.BankAccount + '-' + item.BankAccountDigit"
              :minMatchingChars="0"
              :showOnFocus="true"
              :maxMatches="999"
              placeholder="Todos"
              @hit="filter.IdBankAccount = $event.Id"
              @input="filterBankAccountSearch || (filter.IdBankAccount = null)"
            />
            <button v-if="filterBankAccountSearch" class="typeahead-clear-btn" type="button"
              @click="filterBankAccountSearch = ''; filter.IdBankAccount = null">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="4" class="form-group">
          <label>Situação</label>
          <d-select v-model="filter.IsExcluded">
            <option :value="false">Ativo</option>
            <option :value="true">Inativo</option>
            <option :value="null">Todos</option>
          </d-select>
        </d-col>
        <d-col md="8" class="form-group">
          <label>Banco</label>
          <div class="typeahead-wrapper">
            <VueTypeaheadBootstrap
              v-model="filterBankSearch"
              :data="bankOptions"
              :serializer="item => item.Code + ' - ' + item.Name"
              :minMatchingChars="0"
              :showOnFocus="true"
              :maxMatches="999"
              placeholder="Todos"
              @hit="filter.IdBank = $event.Id"
              @input="filterBankSearch || (filter.IdBank = null)"
            />
            <button v-if="filterBankSearch" class="typeahead-clear-btn" type="button"
              @click="filterBankSearch = ''; filter.IdBank = null">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </d-col>
        <d-col md="4" class="form-group">
          <label>Cód. Histórico</label>
          <input
            class="form-control"
            placeholder="Cód. Histórico"
            type="text"
            maxlength="10"
            v-model="filter.CodeHistory"
            v-on:keyup.enter="ApplyFilter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button @click="ApplyFilter()" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" variant="primary">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button @click="ResetFilter()" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros" variant="primary">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AccountsReceivableConciliation', 'Add')"
      class="btn-float success"
      href="#"
      title="Nova regra"
      v-b-tooltip.hover
      v-on:click="OpenItem($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

export default {
  name: "AccountsReceivableConciliation",
  components: {
    TableListARConciliation: () => import("../sub-components/AccountsReceivableConciliation/TableListARConciliation"),
    VueTypeaheadBootstrap
  },
  data() {
    return {
      items: [],
      editingId: null,
      isSeeing: false,
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      validatedForm: false,
      modalTitle: "Nova Regra de Conciliação",
      pagination: { PageNumber: 1, RowsPerPage: 10, TotalItems: 0 },
      infoItem: this.emptyItem(),
      filter: { IdAccountsReceivableCategory: null, IdBankAccount: null, IdBank: null, CodeHistory: null, IsExcluded: false },
      countFilter: 0,
      categoryOptions: [],
      bankAccountOptions: [],
      bankOptions: [],
      entryCategoryOptions: [],
      formCategorySearch: "",
      formBankAccountSearch: "",
      formEntryCategorySearch: "",
      filterCategorySearch: "",
      filterBankAccountSearch: "",
      filterBankSearch: ""
    };
  },
  mounted() {
    this.List();
    this.LoadOptions();
  },
  methods: {
    emptyItem() {
      return {
        IdAccountsReceivableCategory: null,
        IdBankAccount: null,
        IdEntryCategory: null,
        CodeHistory: null
      };
    },
    OpenItem(e, index, view) {
      e.preventDefault();
      this.validatedForm = false;
      this.infoItem = this.emptyItem();
      this.formCategorySearch = "";
      this.formBankAccountSearch = "";
      this.formEntryCategorySearch = "";

      if (index !== undefined) {
        var item = this.items[index];
        this.editingId = item.Id;
        this.isSeeing = !!view;
        this.modalTitle = view ? "Detalhes da Regra" : "Editar Regra";
        this.GetItem(item.Id);
      } else {
        this.editingId = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Regra de Conciliação";
      }
      this.$bvModal.show("mFormItem");
    },
    GetItem(id) {
      this.loadingModal = true;
      this.$store
        .dispatch("GetAccountsReceivableConciliation", { id: id })
        .then(response => {
          var idCategory = response.AccountsReceivableCategory && response.AccountsReceivableCategory.Id > 0 ? response.AccountsReceivableCategory.Id : null;
          var idBankAccount = response.BankAccount && response.BankAccount.Id > 0 ? response.BankAccount.Id : null;
          var idEntryCategory = response.EntryCategory && response.EntryCategory.Id > 0 ? response.EntryCategory.Id : null;

          this._suppressInput = true;

          this.infoItem = {
            IdAccountsReceivableCategory: idCategory,
            IdBankAccount: idBankAccount,
            IdEntryCategory: idEntryCategory,
            CodeHistory: response.CodeHistory
          };
          this.formCategorySearch = idCategory ? response.AccountsReceivableCategory.Name : "";
          this.formBankAccountSearch = idBankAccount
            ? (response.BankAccount.Bank.Code + " - " + response.BankAccount.Bank.Name.trim() + " Ag: " + response.BankAccount.BankAgency + "-" + response.BankAccount.BankAgencyDigit + " CC: " + response.BankAccount.BankAccount + "-" + response.BankAccount.BankAccountDigit)
            : "";
          this.formEntryCategorySearch = idEntryCategory ? (response.EntryCategory.Code + " - " + response.EntryCategory.Name) : "";

          this.$nextTick(() => {
            this.infoItem.IdAccountsReceivableCategory = idCategory;
            this.infoItem.IdBankAccount = idBankAccount;
            this.infoItem.IdEntryCategory = idEntryCategory;
            this.$nextTick(() => { this._suppressInput = false; });
          });
        })
        .catch(() => {
          this.$makeToast("Erro ao carregar o registro.", "danger", "Erro");
        })
        .finally(() => { this.loadingModal = false; });
    },
    ApplyFilter() {
      this.countFilter = 0;
      if (this.filter.IdAccountsReceivableCategory) this.countFilter++;
      if (this.filter.IdBankAccount) this.countFilter++;
      if (this.filter.IdBank) this.countFilter++;
      if (this.filter.CodeHistory) this.countFilter++;
      this.pagination.PageNumber = 1;
      this.$bvModal.hide("mFilter");
      this.List();
    },
    ResetFilter() {
      this.filter = { IdAccountsReceivableCategory: null, IdBankAccount: null, IdBank: null, CodeHistory: null, IsExcluded: false };
      this.filterCategorySearch = "";
      this.filterBankAccountSearch = "";
      this.filterBankSearch = "";
      this.countFilter = 0;
      this.List();
    },
    List() {
      this.loadingList = true;
      var params = {
        PageNumber: this.pagination.PageNumber,
        RowsPerPage: this.pagination.RowsPerPage,
        "Object.AccountsReceivableCategory.Id": this.filter.IdAccountsReceivableCategory || undefined,
        "Object.BankAccount.Id": this.filter.IdBankAccount || undefined,
        "Object.BankAccount.Bank.Id": this.filter.IdBank || undefined,
        "Object.CodeHistory": this.filter.CodeHistory || undefined,
        "Object.IsExcluded": this.filter.IsExcluded === null ? undefined : this.filter.IsExcluded
      };
      this.$store
        .dispatch("ListAccountsReceivableConciliation", { params: params })
        .then(response => {
          this.items = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(() => {
          this.$makeToast("Erro ao listar registros.", "danger", "Erro");
        })
        .finally(() => { this.loadingList = false; });
    },
    Save() {
      this.validatedForm = true;
      if (!this.infoItem.IdAccountsReceivableCategory) return;
      this.loadingAddUpdate = true;
      var action = this.editingId
        ? "UpdateAccountsReceivableConciliation"
        : "AddAccountsReceivableConciliation";
      var payload = {
        Id: this.editingId || 0,
        AccountsReceivableCategory: { Id: this.infoItem.IdAccountsReceivableCategory },
        BankAccount: this.infoItem.IdBankAccount ? { Id: this.infoItem.IdBankAccount } : null,
        EntryCategory: this.infoItem.IdEntryCategory ? { Id: this.infoItem.IdEntryCategory } : null,
        CodeHistory: this.infoItem.CodeHistory
      };
      this.$store
        .dispatch(action, payload)
        .then(() => {
          this.$makeToast(
            this.editingId ? "Regra atualizada com sucesso." : "Regra cadastrada com sucesso.",
            "success",
            this.editingId ? "Atualizado" : "Cadastrado"
          );
          this.List();
          this.$bvModal.hide("mFormItem");
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro", error);
        })
        .finally(() => { this.loadingAddUpdate = false; });
    },
    ConfirmDelete(id) {
      this.$makeMsgBox("Deseja remover esta regra de conciliação?", "Confirmar", this.Delete, id);
    },
    Delete(id) {
      this.$store
        .dispatch("DeleteAccountsReceivableConciliation", { id: id })
        .then(() => {
          this.$makeToast("Regra removida com sucesso.", "success", "Removido");
          this.List();
        })
        .catch(error => {
          this.$makeToast("Erro ao remover.", "danger", "Erro", error);
        });
    },
    ConfirmDeactivate(id) {
      this.$makeMsgBox("Deseja desativar esta regra de conciliação?", "Confirmar", this.Deactivate, id);
    },
    Deactivate(id) {
      this.$store
        .dispatch("DeactivateAccountsReceivableConciliation", { id })
        .then(() => {
          this.$makeToast("Regra desativada com sucesso.", "success", "Desativado");
          this.List();
        })
        .catch(error => {
          this.$makeToast("Erro ao desativar.", "danger", "Erro", error);
        });
    },
    ConfirmActivate(id) {
      this.$makeMsgBox("Deseja ativar esta regra de conciliação?", "Confirmar", this.Activate, id);
    },
    Activate(id) {
      this.$store
        .dispatch("ActivateAccountsReceivableConciliation", { id })
        .then(() => {
          this.$makeToast("Regra ativada com sucesso.", "success", "Ativado");
          this.List();
        })
        .catch(error => {
          this.$makeToast("Erro ao ativar.", "danger", "Erro", error);
        });
    },
    onCategoryInput(val) {
      if (!this._suppressInput && !val) this.infoItem.IdAccountsReceivableCategory = null;
    },
    onBankAccountInput(val) {
      if (!this._suppressInput && !val) this.infoItem.IdBankAccount = null;
    },
    onEntryCategoryInput(val) {
      if (!this._suppressInput && !val) this.infoItem.IdEntryCategory = null;
    },
    LoadOptions() {
      this.$store.dispatch("ListReceivableCategories")
        .then(r => { this.categoryOptions = (r && r.Objects) || []; })
        .catch(() => {});

      this.$store.dispatch("ListBankAccounts", { params: { RowsPerPage: 999 } })
        .then(r => { this.bankAccountOptions = r || []; })
        .catch(() => {});

      this.$store.dispatch("GetBankAccountBanks")
        .then(r => { this.bankOptions = r || []; })
        .catch(() => {});

      this.$store.dispatch("ListAccountsPayableConciliationEntryCategories")
        .then(r => { this.entryCategoryOptions = r || []; })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.typeahead-wrapper {
  position: relative;
}
.typeahead-clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: none;
  border: none;
  padding: 0 2px;
  line-height: 1;
  color: #aaa;
  cursor: pointer;
  &:hover {
    color: #555;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AccountsReceivableConciliation.vue